
import config from '../config'
import { authorizedFetch }  from '../utils/auth.js'
import { checkStatus } from '../utils/fetch'
import { logOut } from '../actions/users'

export const REQUEST_COMPANIES = 'REQUEST_COMPANIES'
export const SHOW_ERROR_COMPANIES = 'SHOW_ERROR_COMPANIES'
export const RECEIVED_COMPANIES = 'RECEIVED_COMPANIES'
export const SHOW_ADD_COMPANY_FORM = 'SHOW_ADD_COMPANY_FORM'
export const CLOSE_ADD_COMPANY_FORM = 'CLOSE_ADD_COMPANY_FORM'
export const UPDATE_COMPANY_FIELD = 'UPDATE_COMPANY_FIELD'
export const UPDATE_COMPANY = 'UPDATE_COMPANY'
export const UPDATE_COMPANY_SUCCEDED = 'UPDATE_COMPANY_SUCCEDED'
export const DELETE_COMPANY = 'DELETE_COMPANY'
export const DELETE_COMPANY_SUCCEDED = 'DELETE_COMPANY_SUCCEDED'
export const CHANGE_PAGE = 'CHANGE_PAGE_COMPANIES'

export const requestCompanies = () => ({
  type: REQUEST_COMPANIES
})

export const receivedCompanies = (json) => ({
  type: RECEIVED_COMPANIES,
  json: json.data
})

export const displayError = (error) => ({
  type: SHOW_ERROR_COMPANIES,
  error: error
})

export const fetchCompanies = (skip, take) => dispatch => {
    dispatch(requestCompanies())
    authorizedFetch(config.api_url + `companies/list?skip=${skip}&take=${take}`)
      .then(checkStatus)
      .then(response => response.json())
      .then(json => dispatch(receivedCompanies({ data: json  } )))
      .catch(function(error) {
        dispatch(logOut())
      });
}

export const showUpdateCompanyForm = (company) => ({
  type: SHOW_ADD_COMPANY_FORM,
  company: company
})

export const closeAddCompanyForm = () => ({
  type: CLOSE_ADD_COMPANY_FORM,
})

export const updateField = (name, value) => ({
  type: UPDATE_COMPANY_FIELD,
  name: name,
  value: value
})

export const updateCompany = (company) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'companies/update',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ company : company })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateCompanySucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    });
}

export const updateCompanySucceded = (company) => ({
  type: UPDATE_COMPANY_SUCCEDED,
  company: company
})

export const deleteCompany = (company) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'companies/delete',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ company : company })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(deleteCompanySucceded(json)))
    .catch(function(error) {
      dispatch(logOut())
    });
}

export const deleteCompanySucceded = (company) => ({
  type: DELETE_COMPANY_SUCCEDED,
  company: company
})

export const changePage = (pageNumber) => ({
  type: CHANGE_PAGE,
  pageNumber: pageNumber
})



// WEBPACK FOOTER //
// ./src/actions/companies.js